<template>
  <div
    class="absolute top-0 left-0 right-0 bottom-0 overflow-hidden flex flex-col justify-center items-center gap-1 bg-gray-50"
  >
    <img class="max-h-16" v-if="image" :src="image" />
    <p v-if="text">{{ text }}</p>
    <AtomLoadingBar :value="value"></AtomLoadingBar>
  </div>
</template>

<script>
import useSlotText from '@/hooks/useSlotText'
import AtomLoadingBar from '@/components/UI/Atom/LoadingBar'

export default {
  components: {
    AtomLoadingBar,
  },
  props: {
    image: {
      type: String,
      default: null,
    },
    value: AtomLoadingBar.props.value,
  },
  setup(props, { slots }) {
    const { text } = useSlotText(slots)
    return { text }
  },
}
</script>
